// extracted by mini-css-extract-plugin
export var active = "_fr-7";
export var container = "_fr-0";
export var evenWidth = "_fr-4";
export var large = "_fr-5";
export var outlet = "_fr-8";
export var slide = "_fr-2";
export var small = "_fr-6";
export var tab = "_fr-3";
export var tabs = "_fr-1";